import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuTriangleAlert, LuCircleCheck } from 'react-icons/lu';
import api from '../../services/api';
import { zonaCorta } from './DiaZona';

// Zona sugerida para un día (27-oct-2026, backend: empresa/zonas_sugeridas.py). La app sugiere, Lucas decide:
// "Aceptar" cambia la zona del día; "Dejar" no la vuelve a sugerir para ese día. Si el día ya tiene algo,
// la tarjeta va en ámbar y dice con qué choca.
export default function SugerenciaZona({ s, onListo }) {
    const [enviando, setEnviando] = useState(false);
    const responder = async (aceptar) => {
        setEnviando(true);
        try {
            const r = await api.post(`/mapa/semana/${String(s.fecha).slice(0, 10)}/zona-sugerida`, { zona: s.hacia, aceptar });
            const movidas = r.data?.reservasMovidas || 0;
            toast.success(aceptar
                ? `${s.dia}: ahora es ${s.haciaNombre}${movidas ? `. Le sugerimos otro día a ${movidas} reserva${movidas !== 1 ? 's' : ''}` : ''}`
                : `Queda ${s.desdeNombre}`);
            onListo?.();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); }
        finally { setEnviando(false); }
    };
    const choque = s.choque;
    return (
        <div className={`p-3.5 rounded-2xl border space-y-2 ${choque ? 'border-[#B45309]/50 bg-[rgba(180,83,9,0.10)]' : 'border-[#3B5BDB]/50 bg-[rgba(59,91,219,0.10)]'}`}>
            <p className={`text-caption font-black ${choque ? 'text-[#B45309] dark:text-[#F0A500]' : 'text-[#3B5BDB] dark:text-[#93B4FF]'}`}>
                ✨ Sugerencia para el <span className="capitalize">{s.dia}</span>
            </p>
            <p className="text-body-lg font-black text-ink">Pasar de {zonaCorta(s.desde)} a {zonaCorta(s.hacia)}</p>
            <ul className="pl-4 list-disc text-body text-secondary space-y-0.5">
                {s.motivos.map(m => <li key={m}>{m}</li>)}
            </ul>
            {choque ? (
                <p className="flex items-start gap-1.5 text-caption font-bold text-[#92400E] dark:text-[#F3D48C]">
                    <LuTriangleAlert size={14} className="shrink-0 mt-0.5" />
                    <span>
                        Choca con {[choque.reservados.length ? `${choque.reservados.length} reserva${choque.reservados.length !== 1 ? 's' : ''} de la empresa (${choque.reservados.join(', ')})` : null,
                            choque.agendados ? `${choque.agendados} visita${choque.agendados !== 1 ? 's' : ''} agendada${choque.agendados !== 1 ? 's' : ''}` : null].filter(Boolean).join(' y ')}.
                        {choque.reservados.length ? ' Si aceptás, a cada reserva le sugerimos el próximo día de su zona.' : ' Las visitas agendadas quedan como están.'}
                    </span>
                </p>
            ) : (
                <p className="flex items-center gap-1.5 text-caption font-bold text-[var(--etapa-listo-tx)]">
                    <LuCircleCheck size={14} /> El día está libre: sin visitas ni reservas
                </p>
            )}
            <div className="flex gap-2 pt-1">
                <button type="button" disabled={enviando} onClick={() => responder(true)}
                    className="flex-[2] h-11 rounded-xl bg-brand-red text-white text-label font-black active:scale-95 disabled:opacity-40">
                    {choque ? 'Aceptar igual' : 'Aceptar'}: {zonaCorta(s.hacia)}
                </button>
                <button type="button" disabled={enviando} onClick={() => responder(false)}
                    className="flex-1 h-11 rounded-xl bg-chip text-ink text-label font-black active:scale-95 disabled:opacity-40">
                    Dejar {zonaCorta(s.desde)}
                </button>
            </div>
        </div>
    );
}
